import { Seo } from "@/components/Seo";

const LOVABLE_CHECKUP_URL = "https://snap-to-snap-code.lovable.app";

export default function Apply() {
  return (
    <div data-testid="apply-page" className="pt-20">
      <Seo
        title="Get Your Free AI Check-Up | The AI Doctor"
        description="Answer a few questions about how your business runs and get a personalized AI Business Diagnosis — free, no card required."
      />
      <iframe
        src={LOVABLE_CHECKUP_URL}
        title="AI Business Check-Up"
        className="w-full block border-0 h-[calc(100vh-5rem)]"
        data-testid="checkup-iframe"
      />
    </div>
  );
}
